<template>
  <DialogTemplate
    id="shortcutdialog"
    data-tst="preflop_shortcutdialog"
  >
    <PreflopShortcut
      ref="form"
      :namespace="namespace"
      :canAISolve="canAISolve"
      @close="close"
      @confirm="apply"
    />
    <template #dialog_actions>
      <portal-target name="dialog-actions-buttons" />
    </template>
  </DialogTemplate>
</template>

<script>
import DialogTemplate from '@/components/Dialogs/DialogTemplate'
import PreflopShortcut from './PreflopShortcut'

export default {
  name: 'PreflopShortcutDialog',
  components: {
    DialogTemplate,
    PreflopShortcut,
  },
  props: {
    dialog: Object,
  },
  methods: {
    close() {
      this.$store.dispatch('router_rm_dialog', 'preflop-shortcut-dialog')
    },
    apply() {
      this.$refs.form.apply()
      this.close()
    },
  },
  computed: {
    namespace() {
      return this.dialog.namespace || ''
    },
    canAISolve() {
      return !!this.dialog.canAISolve
    },
  },
}
</script>
